import React from 'react';
import { TextField, Paper } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { listPage } from '../../services/CommonService';
import color from '../../assets/css/colors';
import fontFamily from '../../assets/css/fonts';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  autocompleteWrapper: {
    '& .MuiAutocomplete-inputRoot': {
      padding: '7px 15px 8px 15px !important',
      height: 48,
    },
    '& .MuiAutocomplete-option': {
      backgroundColor: 'red',
    },
    '& .MuiAutocomplete-endAdornment': {
      top: 'calc(50% - 15px)',
      '& svg': {
        width: '22px !important',
        height: '22px !important',
      },
    },
  },
  paper: {
    fontFamily: fontFamily.label,
    fontSize: 15,
    fontWeight: 600,
    backgroundColor: color.light.main,
  },
}));

export default function SelectPage(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [inputValue, setInputValue] = React.useState(props.value);

  const setPropsValue = (value, id) => {
    const returnValue = {
      name: props.name,
      value: value || '',
      pageId: id || 0,
    };

    props.onChange({
      currentTarget: returnValue,
      target: returnValue,
    });
  };

  const handleOnBlur = async (value, id) => {
    const o = options.find((o) => o.pageName === value);
    if (o) {
      setPropsValue(value, o.pageId);
      return;
    }

    if (props.freeSolo) {
      setPropsValue(value, id);
      return;
    }

    // if selected value does not exist in options and is not a free solo
    setInputValue('');
    setPropsValue('');
  };

  //set local input value and get options
  const handleInputChange = async (event, value) => {
    if (!event) return;
    if (event.type === 'blur') return;
    if (event.type === 'click' && value) return;

    setInputValue(value);
    getOptions(value);
  };

  //get list from backend
  const getOptions = async (value) => {
    var { pagesList } = await listPage({
      key: value,
      limit: 50,
    });

    setOptions(pagesList.filter((s) => s.pageName));
  };

  React.useEffect(() => {
    if (!options.length && !props.value) {
      //removed this from if condition [open]
      getOptions(props);
    }
    // eslint-disable-next-line
  }, [props]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (
        e.target.value.length === 0 ||
        options.find((o) => o.pageName === e.target.value)
      ) {
        return;
      }
      if (!options.find((o) => o.pageName.indexOf(e.target.value) === -1)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  };

  return (
    <Autocomplete
      className={classes.autocompleteWrapper}
      style={props.style}
      disabled={props.disabled}
      freeSolo={props.freeSolo}
      id={props.name}
      onInputChange={handleInputChange}
      onBlur={() => {
        handleOnBlur(inputValue);
      }}
      blurOnSelect={false}
      onChange={(_, v) => {
        setPropsValue(v?.pageName, v?.pageId);
        setInputValue(v?.pageName || '');
      }}
      getOptionSelected={(option, value) =>
        option.pageName === value.pageName || options.find((o) => o.pageName !== value)
      }
      getOptionLabel={(option) => {
        return option.pageName;
      }}
      inputValue={inputValue}
      options={options}
      groupBy={(option) => option.menu + ' / ' + option.subMenu}
      name={props.name}
      autoHighlight={false}
      clearOnEscape={true}
      onClose={() => {
        setOpen(false);
      }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      PaperComponent={({ children }) => (
        <Paper className={classes.paper}>{children}</Paper>
      )}
      renderInput={(params) => {
        params.inputProps.onKeyDown = props.onKeyDown ? props.onKeyDown : handleKeyDown;
        return (
          <TextField
            {...params}
            name={props.name}
            required={props.required}
            disabled={props.disabled}
            label={props.label}
            InputLabelProps={{ shrink: true }}
          />
        );
      }}
    />
  );
}
